import React from "react"

import { useRecoilValue } from "recoil"

import { userState } from "@fuse/recoil/signup"

import { auth } from "@firebaseConfig/clientApp"

import { devEmailVerificationUtils, isDev } from "@fuse/utils/DeviceDection"

/**
 * Dev-only component that shows email verification status
 * Only visible in development mode
 */
export const DevEmailIndicator: React.FC = () => {
  const user = useRecoilValue(userState)

  // Only show in development
  if (!isDev()) return null

  const currentUser = auth.currentUser
  const isDevVerified = currentUser?.uid
    ? devEmailVerificationUtils.isDevVerified(currentUser.uid)
    : false
  const devEmail = currentUser?.uid
    ? devEmailVerificationUtils.getDevVerifiedEmail(currentUser.uid)
    : null

  if (!isDevVerified || !user?.emailVerified) return null

  return (
    <div className="fixed bottom-4 right-4 bg-green-600/90 text-white px-3 py-2 rounded-lg text-xs font-mono z-50 backdrop-blur-sm">
      <div className="flex items-center gap-2">
        <span className="w-2 h-2 bg-green-300 rounded-full animate-pulse"></span>
        <span>DEV: Fake email verified</span>
      </div>
      <div className="text-green-200 text-xs mt-1">📧 {devEmail}</div>
    </div>
  )
}
